import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let maskScene: any = null,
    titleScene: any = null;
export default function O() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (maskScene) AniContainer.removeScene(maskScene);
                if (titleScene) AniContainer.removeScene(titleScene);

                const clientH = (window.innerHeight || 0) * 0.6;
                const startH = Math.min(clientH, 450);
                maskScene = AniContainer.create({
                    triggerElement: '.dpu-detail-O',
                    triggerHook: 1,
                    offset: startH,
                    duration: 300, //window.innerHeight * 2,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                    //onLeave: () => setTextEnter(false),
                });

                // maskScene = AniContainer.create({
                //     asyncFromTo: [['.dpu-detail-O .mask', { opacity: 0 }, { opacity: 1 }]],
                //     triggerElement: '.dpu-detail-O',
                //     triggerHook: 1,
                //     offset: window.innerHeight,
                //     duration: window.innerHeight / 2,
                // });

                // titleScene = AniContainer.create({
                //     asyncFromTo: [['.dpu-detail-O .title', { opacity: 0, y: window.innerHeight / 4 }, { opacity: 1, y: 0 }]],
                //     triggerElement: '.dpu-detail-O',
                //     triggerHook: 1,
                //     offset: window.innerHeight * 1.5,
                //     duration: window.innerHeight / 2,
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (maskScene) AniContainer.removeScene(maskScene);
                if (titleScene) AniContainer.removeScene(titleScene);
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-O dpu-detail-section ${css['dpu-detail-O']}`}>
            <div className={`sticky-box${textEnter ? ' textEnter' : ''}`}>
                <div className="img-box">
                    <EFPicture
                        src={'/responsive/picture/delta-pro-ultra/launch/15.jpg'}
                        srcPad={'/responsive/picture/delta-pro-ultra/launch/15_768.jpg'}
                        srcMobile={'/responsive/picture/delta-pro-ultra/launch/15_768.jpg'}
                        alt={t('secO_title')}
                    />
                    <div className="mask"></div>
                    <div className="title-box">
                        <h2 className="title">{t('secO_title')}</h2>
                    </div>
                </div>
            </div>
        </section>
    );
}
